import * as Utils from '../../utils/sort'

function appendFilterIsNotExists(filterList, title, value, selected) {
  const selectedDefault = false
  const isExistFilter = filterList.filter(({ title: filterTitle }) => filterTitle === title)

  if (isExistFilter.length) {
    return [...filterList]
  }

  return [
    ...filterList,
    {
      title,
      value: value || title,
      selected: selected || selectedDefault,
    },
  ]
}

function getFilterFlagTranslated(filter, filterGroupName, translateHelper) {
  const filterNormalized = filter.toLowerCase().replace(/\s/g, '')

  return translateHelper(`changelog.filter.${filterGroupName}.flags.${filterNormalized}.label`, filter)
}

function builderFilter(changelogs, translateHelper) {
  return changelogs.reduce(
    (acc, { node: { frontmatter: data } }) => {
      const sortByAttr = 'title'
      const { month, app, changeType } = data
      const months = appendFilterIsNotExists(acc.months, month)

      const apps = app.reduce((_, appItem) => {
        const appTranslated = getFilterFlagTranslated(appItem, 'solution', translateHelper)
        return appendFilterIsNotExists(acc.apps, appTranslated, appItem)
      }, [])

      const changeTypeTranslated = getFilterFlagTranslated(changeType, 'changeType', translateHelper)
      const changeTypes = appendFilterIsNotExists(acc.changeTypes, changeTypeTranslated, changeType)

      return {
        months: Utils.descendingSortString(months, sortByAttr),
        apps: Utils.ascendingSortString(apps, sortByAttr),
        changeTypes: Utils.ascendingSortString(changeTypes, sortByAttr),
      }
    },
    { months: [], apps: [], changeTypes: [] }
  )
}

function getValuesOfFilterSelected(filter) {
  return filter.reduce((acc, { value, selected }) => (selected ? [...acc, value] : acc), [])
}

function getFiltersSelected(filter) {
  const months = getValuesOfFilterSelected(filter.months)
  const apps = getValuesOfFilterSelected(filter.apps)
  const changeTypes = getValuesOfFilterSelected(filter.changeTypes)

  return { months, apps, changeTypes }
}

function filterToggleSelect(filterSelected, filterGroupSelected) {
  return filterGroupSelected.map(filterItem => {
    const { value, selected } = filterItem

    return value === filterSelected ? { ...filterItem, selected: !selected } : filterItem
  })
}

function getCountFilterSelected(filterGroup) {
  const filtersSelected = Object.values(filterGroup)

  return filtersSelected.reduce((acc, filterSelected) => (acc += filterSelected.length), 0)
}

function getChangelogStyles(type, styles) {
  const { appStyles, infoStyles, warningStyles, dangerStyles } = styles
  const flags = {
    Developers: appStyles,
    Tutorials: appStyles,
    'Member Areas': appStyles,
    Sales: appStyles,
    Subscriptions: appStyles,
    Webhook: appStyles,
    Credentials: appStyles,
    Added: infoStyles,
    Fixed: infoStyles,
    Changed: warningStyles,
    Security: warningStyles,
    Deprecated: dangerStyles,
    Removed: dangerStyles,
  }

  return flags[type]
}

export { builderFilter, getCountFilterSelected, getFiltersSelected, filterToggleSelect, getChangelogStyles }
